import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SoapNotesState {
  soapNotesMarkdown: string;
  soapNotesGeneratedAt: Date | undefined;
  isGenerating: boolean;
  setIsGenerating: (generating: boolean) => void;
  setSoapNotes: (notes: string) => void;
  setSoapNotesGeneratedAt: (date: Date | undefined) => void;
  resetSoapNotes: () => void;
}

const SoapNotesContext = createContext<SoapNotesState | undefined>(undefined);

interface SoapNotesProviderProps {
  children: ReactNode;
}

export const SoapNotesProvider: React.FC<SoapNotesProviderProps> = ({
  children,
}) => {
  const [soapNotesMarkdown, setSoapNotesMarkdown] = useState<string>('');
  const [soapNotesGeneratedAt, setSoapNotesGeneratedAt] = useState<
    Date | undefined
  >(undefined);
  const [isGenerating, setIsGenerating] = useState<boolean>(false);

  const setSoapNotes = (notes: string) => {
    setSoapNotesMarkdown(notes);
  };

  const resetSoapNotes = () => {
    setSoapNotesMarkdown('');
    setSoapNotesGeneratedAt(undefined);
  };

  return (
    <SoapNotesContext.Provider
      value={{
        soapNotesMarkdown,
        soapNotesGeneratedAt,
        isGenerating,
        setIsGenerating,
        setSoapNotes,
        setSoapNotesGeneratedAt,
        resetSoapNotes,
      }}
    >
      {children}
    </SoapNotesContext.Provider>
  );
};

export const useSoapNotes = (): SoapNotesState => {
  const context = useContext(SoapNotesContext);
  if (context === undefined) {
    throw new Error('useSoapNotes must be used within a SoapNotesProvider');
  }
  return context;
};
